/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect } from 'react';

import { TpaSettingsProvider } from '@wix/tpa-settings/dist/src/contexts';
import loadable from '@loadable/component';

// redux
import useSelector from '../../hooks/useTypedSelector';
import useDispatch from '../../hooks/useTypedDispatch';
import { getInstance, getOrigCompId } from '../../services/wixServices';

import {
  getInitialData,
  selectLoadingStatus,
} from '../../store/adunits/adunitsSlice';

const Settings = loadable(() => import('./Settings'), {
  ssr: false,
  fallback: <div />,
});

import './style/Settings.global.scss';

const SettingsRoot = () => {
  const dispatch = useDispatch();
  const loadingStatus = useSelector(selectLoadingStatus);

  useEffect(() => {
    const signedinstance = getInstance();
    const compId = getOrigCompId();

    if (loadingStatus === 'idle') {
      dispatch(getInitialData({ instance: signedinstance, compId }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return <div />;
  }
  return (
    <TpaSettingsProvider Wix={window.Wix}>
      <Settings />
    </TpaSettingsProvider>
  );
};

export default SettingsRoot;
